// extracted by mini-css-extract-plugin
module.exports = {"title":"AppHeader_title__yg6ew"};